import {
  POST_ADMIN_USER_LOGIN,
  POST_ADMIN_USER_LOGIN_SUCCESS,
  POST_ADMIN_USER_LOGIN_ERROR
} from "./actionTypes"

export const postAdminUserLogin = (user_login, url_filter = "") => {
  return {
    type: POST_ADMIN_USER_LOGIN,
    payload: user_login,
    url_filter: url_filter
  }
}

export const postAdminUserLoginSuccess = user_login => {
  return {
    type: POST_ADMIN_USER_LOGIN_SUCCESS,
    payload: user_login,
  }
}

export const postAdminUserLoginError = error => {
  return {
    type: POST_ADMIN_USER_LOGIN_ERROR,
    payload: error,
  }
}